import { CaretCircleDown } from '@phosphor-icons/react';

export default CaretCircleDown;
